import { memo } from "react";
import { useShallow } from "zustand/react/shallow";

import useRowKeyboardNavigation from "ds/components/Table/hooks/useKeyboardNavigation/useRowKeyboardNavigation";
import { selectVisibleColumns } from "ds/components/Table/store/useTableStore/selectors";

import usePersonalSettingsSpacesTableStore from "../../usePersonalSettingsSpacesTableStore";
import PersonalSettingsSpacesTableBodyRow from "..";
import { selectTableRowByIndex } from "../../usePersonalSettingsSpacesGroupsStore/tableDataSelectors";
import usePersonalSettingsSpacesTableGroupsStore from "../../usePersonalSettingsSpacesGroupsStore";
import PersonalSettingsSpacesTableItemRowContent from "./Content";

type PersonalSettingsSpacesTableRowItemProps = {
  rowIndex: number;
  measureRef: (node: HTMLDivElement) => void;
};

const PersonalSettingsSpacesTableRowItem = ({
  rowIndex,
  measureRef,
}: PersonalSettingsSpacesTableRowItemProps) => {
  const { columns } = usePersonalSettingsSpacesTableStore(
    useShallow((state) => ({
      columns: selectVisibleColumns(state),
    }))
  );

  const { row } = usePersonalSettingsSpacesTableGroupsStore(
    useShallow((state) => ({
      row: selectTableRowByIndex(state, rowIndex),
    }))
  );

  const keyboardProps = useRowKeyboardNavigation({ isGroup: false });

  return (
    <PersonalSettingsSpacesTableBodyRow
      {...keyboardProps}
      forwardRef={measureRef}
      dataIndex={rowIndex}
      isGroupChild
    >
      <PersonalSettingsSpacesTableItemRowContent columns={columns} row={row} />
    </PersonalSettingsSpacesTableBodyRow>
  );
};

export default memo(PersonalSettingsSpacesTableRowItem);
